<template>
  <div class="main">
    <div class="title">
      <div class="name">专家邀请</div>
    </div>
    <div class="box">
      <div class="box-title">邀请链接</div>
      <div class="box-href">
        <p>网址 :  {{urlStr + url + oid}}</p>
        <span @click="copy(urlStr + url + oid)">复制</span>
      </div>
    </div>
    <div style="width: 100%;height: 10px;"></div>
    <div class="box">
      <div class="box-title">邀请海报</div>
      <div class="img-box">
        <img :src="path" v-show="path" alt="">
      </div>
      <div class="btn-box">
        <a :href="path" target="_blank">保存邀请函</a>
      </div>
    </div>
  </div>
</template>
<script>
import {getSetting, poster} from "@/api/index";
import {urlStr} from "@/config";
export default {
  name: "invitation",
  data() {
    return {
      urlStr:urlStr,
      id:'',
      url:'/h5/checkinh5.html?register_type=1&showId=',
      path:'',
      oid:''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 1,
      act: 3,
      name: '专家管理 > 专家邀请'
    })
    this.getSetting()

  },
  methods: {
    async getSetting() {
      let _res = await getSetting(
          this.user.mid
      );
      if (_res.status === 200) {
        this.oid =  _res.data.setting.oid
        this.Poster()
      } else {
        this.$message.error(_res.msg)
      }
    },
    copy(url) {
      // 模拟 输入框
      var cInput = document.createElement("input");
      cInput.value = url;
      document.body.appendChild(cInput);
      cInput.select(); // 选取文本框内容
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("copy");
      this.$message({
        type: "success",
        message: "复制成功"
      });
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput);
    },

    //
    async Poster() {
      let path = this.urlStr + this.url + this.oid
      let _res = await poster(
          this.user.mid,
          path,1
      );
      if (_res.status === 200) {
        this.path = this.urlStr + _res.data.img
      } else {
        this.$message.error(_res.msg)
      }
    },

  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.main {
  .title {
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }

  .box {
    width: 100%;
    border-radius: 10px;
    padding: 20px;
    background-color: #ffffff;
    .btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-bottom: 30px;
      a {
        width: 201px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .img-box {
      width: 297px;
      height: 437px;
      background-color: #f3f7fb;
      border-radius: 10px;
      padding: 15px;
      margin: 30px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .box-href {
      width: 824px;
      height: 60px;
      background-color: #f3f7fb;
      border-radius: 10px;
      margin: 40px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        width: 670px;
        height: 40px;
        background-color: #ffffff;
        border-radius: 10px;
        font-size: 14px;
        letter-spacing: 1px;
        color: #333333;
        line-height: 40px;
        padding: 0 20px;
      }
      span {
        width: 99px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 20px;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
        margin-left: 15px;
      }
    }
    .box-title {
      width: 100%;
      font-size: 18px;
      color: #0a2240;
    }
  }


}
</style>


